import restDataService from './restDataService';

// Single BFF call: plan details plus the identity token ClinicalSearch needs.
export const GetNetworkSearchContext = async clientCode =>
	restDataService.get('api/NetworkSearch/context', {
		params: {
			clientCode,
		},
	});

export const GetRecruitmentPagesFn = async (
	clinicalSpecialtyAndDistinction,
	region
) =>
	restDataService
		.get('api/ContentManagement/Recruitment/PreLogin/RecruitmentPages', {
			params: {
				ClinicalSpecialtyAndDistinction:
					clinicalSpecialtyAndDistinction,
				Region: region,
			},
		})
		.catch(error => error.response);

export const GetResourceGroupsFn = async () =>
	restDataService
		.get('api/ContentManagement/PreLogin/ResourceGroups', {
			params: {
				resourceGroupArea: 'Provider',
			},
		})
		.catch(error => error.response);

export const GetResourceGroupFn = async groupPageId =>
	restDataService
		.get(`api/ContentManagement/PreLogin/ResourceGroups/${groupPageId}`)
		.catch(error => error.response);

export const GetResourcePageFn = async pageId =>
	restDataService
		.get(`api/ContentManagement/PreLogin/ResourcePages/${pageId}`)
		.catch(error => error.response);

export const GetAshlinkPublicUserRedirectionsFn = async () =>
	restDataService
		.get('api/UserManagement/AshlinkPublicUserRedirections')
		.catch(error => error.response);

export const GetFitnessJoinOurNetworkSectionsFn = async () =>
	restDataService
		.get('api/ContentManagement/Fitness/PreLogin/JoinOurNetworkSections')
		.catch(error => error.response);

export const GetFAQBySpecialtyFn = async clinicalSpecialtyAndDistinction =>
	restDataService
		.get('api/ContentManagement/Clinical/PreLogin/FAQBySpecialty', {
			params: {
				ClinicalSpecialtyAndDistinction:
					clinicalSpecialtyAndDistinction,
			},
		})
		.catch(error => error.response);

export const GetJoinOurNetworkGroupsFn = async () =>
	restDataService
		.get('api/ContentManagement/Clinical/PreLogin/JoinOurNetworkGroups')
		.catch(error => error.response);

export const GetPreLoginAnnouncementsFn = async () =>
	restDataService
		.get('api/ContentManagement/PreLogin/Announcements')
		.catch(error => error.response);

export const GetJONGroup = async pageId =>
	restDataService.get('api/ContentManagement/PreLogin/PreLoginPages', {
		params: {
			pageId,
		},
	});

export const getIsAuthenticated = async () =>
	restDataService.get('auth/isauthenticated').catch(error => error.response);

export const getClearCookies = async () =>
	restDataService
		.get('auth/clearsessioncookie')
		.catch(error => error.response);
